
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { authKey, GET_ONHOLD_INVOICE_LIST, CLOSE_INVOICE_ISSUE } from '../../../common/URLs';
import Moment from 'moment';
import jwt from 'jwt-decode';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Container, Card, CardContent, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, Button } from '@mui/material';
import { Fab } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { ErrorPopover } from '../../../common/ErrorPopover/errorPopover';
import { DialogContent, Dialog, DialogActions } from '@mui/material';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import apiClient from "../../../axios";

function OnHoldInvoiceList() {

    const navigate = useNavigate();
    const [onholdInvoices, setOnholdInvoices] = useState();
    const [closeInvoiceResponse, setCloseInvoiceResponse] = useState();
    const invoiceData = useLocation().state?.selectedRow;
    const [isApiCalled, setIsApiCalled] = useState(false);

    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalOpen1 = () => setLogModalOpen(true);

    const [logModalOpen, setLogModalOpen] = useState(false);
    const [logModalOpen2, setLogModalOpen2] = useState(false);
    const handleLogModalOpen2 = () => setLogModalOpen2(true);
    const handleLogModalClose2 = () => setLogModalOpen2(false);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);


    useEffect(() => {
        getOnholdInvoices();
    }, [invoiceData]);

    const getOnholdInvoices = (e) => {
        loaderService.showLoader()
        apiClient
            .post(GET_ONHOLD_INVOICE_LIST,
                {
                    "consignmentNo": invoiceData.consignmentNo
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setOnholdInvoices(response.data.invoiceIssueList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    // const onConfirmUpdate = (e) => {
    //     handleConfirmClose();
    //     onCloseInvoiceIssue();
    //     // onSubmit(e);
    // }

    const onConfirmUpdate = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await onCloseInvoiceIssue();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen(false);
            setIsApiCalled(false);
        }
    };

    const onSubmitButtonClick = (e) => {
        handleConfirmOpen();
    }

    const onCloseInvoiceIssue = () => {
        loaderService.showLoader()
        apiClient
            .post(CLOSE_INVOICE_ISSUE,
                {
                    // "stakeholderType": "string",
                    // "stakeholderUrn": "string",
                    "consignmentNo": onholdInvoices?.[0].consignmentNo,
                    "issueNumber": onholdInvoices?.[0].issueNumber,
                    // "materialType": "string",
                    // "qualityParameter": "string",
                    "actualValue": onholdInvoices?.[0].actualValue,
                    "recordedValue": onholdInvoices?.[0].recordedValue,
                    "postInspectionValue": onholdInvoices?.[0].postInspectionValue,
                    // "toleranceLimit": 0,
                    // "maximumLimit": 0,
                    // "minimumLimit": 0,
                    // "comment": "string"
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setCloseInvoiceResponse(response.data);
                getOnholdInvoices();
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const columns = [
        { field: 'consignmentNo', headerName: 'Consignment No', width: 150 },
        { field: 'issueNumber', headerName: 'Issue Number', width: 160 },
        { field: 'invoiceNo', headerName: 'Invoice Number', width: 160 },
        {
            field: 'invoiceDate', headerName: 'Invoice Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'invoiceAmount', headerName: 'Invoice Amount', width: 150 },
        { field: 'quantity', headerName: 'Quantity', width: 150 },
        { field: 'invoiceType', headerName: 'Invoice Type', width: 160 },
        { field: 'invoiceStatus', headerName: 'Invoice Status', width: 160 },
        { field: 'materialType', headerName: 'Material Type', width: 150 },
        { field: 'qualityParameter', headerName: 'Quality Parameter', width: 150 },
        { field: 'actualValue', headerName: 'Actual Value', width: 150 },
        { field: 'recordedValue', headerName: 'Recorded Value', width: 150 },
        { field: 'postInspectionValue', headerName: 'Post Inspection Value', width: 150 },
    ];

    useEffect(() => {
        if (closeInvoiceResponse) {
            if (closeInvoiceResponse.isSuccess === true) {
                toast.success(closeInvoiceResponse?.message)
                // handleLogModalOpen2();
            }
            else {
                toast.error(closeInvoiceResponse?.message ? closeInvoiceResponse?.message : "Error")
                // handleLogModalOpen();
            }
        }
    }, [closeInvoiceResponse]);

    return (
        <>
            <Container maxWidth="xxl">
                <Typography variant="h5" gutterBottom>
                    <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab>
                    On-Hold Invoices
                </Typography>
                <Card>
                    <CardContent>
                        <Box style={{ height: 400, width: '100%' }}>
                            {
                                onholdInvoices &&
                                <DataGrid rows={onholdInvoices}
                                    columns={columns}
                                    pageSize={10}
                                    getRowId={(row) => row.invoiceNo}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                />
                            }
                        </Box>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100 }} variant="contained" onClick={() => onSubmitButtonClick()}>Update</Button>
                </Box>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmUpdate} onClose={handleConfirmClose} action="Update" />

            {/* <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
                <DialogContent>
                    <ConfirmPopover title={closeInvoiceResponse?.message ? closeInvoiceResponse?.message : "Error"} hideLink={true} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogModalClose2}>OK</Button>
                </DialogActions>
            </Dialog> */}
        </>
    );
}
export default OnHoldInvoiceList;
